<template>
  <div>
    <div style="margin-bottom: 5px">
      <el-button type="warning" size="small" @click="pdf_init">从PDF载入</el-button>
      <el-button type="warning" size="small" @click="img_init">从图片添加</el-button>
      <el-button type="primary" size="small" @click="save_paper_img">保存</el-button>
    </div>
    <div class="canvas-container" style="display: none">
      <canvas ref="myCanvas"> </canvas>
    </div>
    <input type="file" ref="pdf_file" style="display: none" @change="read_pdf" />
    <input type="file" ref="img_file" style="display: none" @change="read_img" />
    <el-row :gutter="10">
      <el-col
        v-for="(img, index) in imgs"
        :key="index"
        :span="6"
        style="height: 350px; position: relative"
      >
        <div
          style="
            background-color: rgba(255, 255, 255, 0.6);
            position: absolute;
            top: 0;
            left: 0;
            z-index: 999;
            width: 100%;
            font-size: 24px;
            font-weight: bold;
            color: red;
          "
          align="center"
        >
          <i
            class="el-icon-delete"
            style="float: right; margin-right: 20px; font-size: 32px"
            @click="del_img(index)"
          ></i>
          <i
            class="el-icon-caret-left"
            style="float: left; margin-left: 20px; font-size: 32px"
            @click="move_img(index, 'f')"
          ></i>
          <i
            class="el-icon-caret-right"
            style="float: left; font-size: 32px"
            @click="move_img(index, 'b')"
          ></i>
        </div>
        <div
          style="
            background-color: rgba(255, 255, 255, 0.6);
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 999;
            width: 100%;
            font-size: 24px;
            font-weight: bold;
            color: red;
          "
          align="center"
        >
          第{{ index + 1 }}页
        </div>
        <div
          style="
            width: 100%;
            height: 100%;
            overflow-y: auto;
            box-sizing: border-box;
            border: 1px solid;
          "
        >
          <el-image :src="`https://cjyc.beautop.cn/chengjifabu/answer_img/${img}`">
          </el-image>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import global_ from "../global";
import pdfJS from "pdfjs-dist";
const max_size = 2000;
const admin_api = global_.admin_api;
export default {
  name: "PaperEditer",
  props: ["exam_id"],
  data() {
    return {
      pdfData: "",
      imgs: [],
      scale: 3,
      loadFinished: false,
    };
  },
  created() {
    this.query_paper_img();
  },
  watch: {
    exam_id() {
      this.imgs = [];
      this.query_paper_img();
    },
  },
  methods: {
    save_paper_img() {
      this.$confirm("保存试卷？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let request_data = {
          service_name: "save_paper_img",
          exam_id: this.exam_id,
          imgs: this.imgs,
        };
        this.axios.post(admin_api, request_data).then((response) => {
          let response_data = response.data;
          let result_code = response_data["result_code"];
          let result_info = response_data["result_info"];
          if (result_code === "00") {
            this.$alert(result_info, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert(result_info, "提示", {
              confirmButtonText: "确定",
            });
          }
        });
      });
    },
    read_pdf() {
      try {
        let inputDom = this.$refs.pdf_file;
        let file = inputDom.files[0];
        let fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          this.pdfData = atob(
            fileReader.result.substring(fileReader.result.indexOf(",") + 1)
          );
          this.previewPDF();
        };
      } catch (e) {
        console.log(e);
      }
    },
    previewPDF() {
      // 引入pdf.js的字体
      // let CMAP_URL = 'https://unpkg.com/pdfjs-dist@2.0.943/cmaps/'
      //读取base64的pdf流文件
      pdfJS
        .getDocument({
          data: this.pdfData, // PDF base64编码
          // cMapUrl: CMAP_URL,
          cMapPacked: true,
        })
        .then((pdf) => {
          this.loadFinished = true;
          let numPages = pdf.numPages;
          let pageNumber = 1;
          this.getPage(pdf, pageNumber, numPages);
        });
    },
    getPage(pdf, pageNumber, numPages) {
      let _this = this;
      pdf.getPage(pageNumber).then((page) => {
        // 获取DOM中为预览PDF准备好的canvasDOM对象
        let canvas = this.$refs.myCanvas;
        let _w= page.view[2]
        let _h= page.view[3]
        let scale = 1;
        if (_w >= _h) {
          scale = max_size / _w;
        } else {
          scale = max_size / _h;
        }
        let viewport = page.getViewport(scale);
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        let ctx = canvas.getContext("2d");
        let renderContext = {
          canvasContext: ctx,
          viewport: viewport,
        };
        page.render(renderContext).then(() => {
          pageNumber += 1;
          canvas.toBlob(
            (blob) => {
              let formData = new FormData();
              formData.append("service_name", "save_img_paper");
              formData.append("exam_id", String(this.exam_id));
              formData.append("img_file", blob);
              _this.axios.post(admin_api, formData).then((response) => {
                let result_code = response.data["result_code"];
                let result_info = response.data["result_info"];
                if (result_code === "00") {
                  _this.imgs.push(result_info);
                  if (pageNumber <= numPages) {
                    _this.getPage(pdf, pageNumber, numPages);
                  }
                } else {
                  this.error_hander(response);
                }
              });
            },
            "image/jpeg",
            0.75
          );
        });
      });
    },
    pdf_init() {
      this.$refs.pdf_file.value = "";
      this.$refs.pdf_file.click();
    },
    img_init() {
      this.$refs.img_file.value = "";
      this.$refs.img_file.click();
    },
    read_img(e) {
      let canvas = this.$refs.myCanvas;
      let ctx = canvas.getContext("2d");
      let file = e.target.files[0];
      let url = URL.createObjectURL(file);
      let img = new Image();
      img.src = url;
      img.onload = () => {
        if (img.naturalWidth < max_size && img.naturalHeight < max_size) {
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
        } else if (img.naturalWidth > img.naturalHeight) {
          let ratio = img.naturalWidth / img.naturalHeight;
          canvas.width = max_size;
          canvas.height = canvas.width / ratio;
        } else {
          let ratio = img.naturalHeight / img.naturalWidth;
          canvas.height = max_size;
          canvas.width = canvas.height / ratio;
        }
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(
          (blob) => {
            let formData = new FormData();
            formData.append("service_name", "save_img_paper");
            formData.append("exam_id", String(this.exam_id));
            formData.append("img_file", blob);
            this.axios.post(admin_api, formData).then((response) => {
              let result_code = response.data["result_code"];
              let result_info = response.data["result_info"];
              if (result_code === "00") {
                this.imgs.push(result_info);
              } else {
                this.error_hander(response);
              }
            });
          },
          "image/jpeg",
          0.75
        );
      };
    },
    error_hander(response) {
      let result_code = response.data["result_code"];
      let result_info = response.data["result_info"];
      if (result_code === "90") {
        this.$store.commit("set_login_state", false);
        this.$router.replace("/login");
      } else {
        this.$message({ message: result_info, duration: 1000, type: "error" });
      }
    },
    del_img(index) {
      this.$confirm(`确定要删除第${index + 1}页试卷吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.imgs.splice(index, 1);
      });
    },
    move_img(index, direction) {
      if (index === 0 && direction === "f") {
        return;
      }
      if (index === this.imgs.length - 1 && direction === "b") {
        return;
      }
      let tip = "";
      if (direction === "f") {
        tip = "前";
      } else {
        tip = "后";
      }
      this.$confirm(`确定要把第${index + 1}页试卷${tip}移吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let _ = this.imgs.splice(index, 1);
        if (direction === "f") {
          this.imgs.splice(index - 1, 0, _);
        } else {
          this.imgs.splice(index + 1, 0, _);
        }
      });
    },
    query_paper_img() {
      let request_data = {
        service_name: "query_paper_img",
        exam_id: this.exam_id,
      };
      this.axios.post(admin_api, request_data).then((response) => {
        let result_code = response.data["result_code"];
        let result_info = response.data["result_info"];
        if (result_code === "00") {
          this.imgs = result_info;
        } else {
          this.error_hander(response);
        }
      });
    },
  },
};
</script>
